import styled from 'styled-components';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledTagCategory = styled.a`
  display: inline-block;
  padding: 0.1rem 1rem 0.05rem;
  line-height: 1.7rem;

  background-color: ${props => props.theme.colors[props.type]};
  color: ${props => props.theme.colors.dark};

  ${mediaqueries.lessThan('tablet')`
    font-size: ${props => props.theme.fontSize.small};
    width: fit-content;
  `};

  &:hover {
    color: ${props => props.theme.colors.light};
  }
`;

const StyledTagText = styled.span`
  text-transform: uppercase;
  font-family: ${props => props.theme.fonts.medium};

  ${mediaqueries.lessThan('mobile')`
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

export { StyledTagCategory, StyledTagText };
